var req = require("!!/Users/admin/TreeSt/front/node_modules/pug-loader/index.js!/Users/admin/TreeSt/front/src/app/admin/admin-delivery/admin-parcels/admin-parcels.component.pug");
module.exports = (req['default'] || req).apply(req, [])